angular.module('zc.core')
  .component('zcSessionPredictionDistribution', {
    templateUrl: '/templates/core/components/session_prediction_distribution/session_prediction_distribution.html',
    bindings: {
      campaign: '<',
      sessions: '<',
      disabled: '<',
      field: '@'
    },
    controller: sessionPredictionDistributionController,
  });

sessionPredictionDistributionController.$inject = ['$rootScope', '$scope', '$translate', 'ChartV2', 'columnChartV2Config'];
function sessionPredictionDistributionController($rootScope, $scope, $translate, ChartV2, columnChartV2Config) {
  const vm = this;

  const RANDOM_DIGIT = 10;
  const MIN = 0;
  const MAX = 100;
  const STEP = 1;
  const PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  const ranges = _.range(MIN, MAX, STEP);
  const chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: { stacking: 'normal' }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      },
    }
  });

  let deregisterStateChangeStart;

  vm.$onInit = () => {
    if(vm.field === 'predictions_max_before_cart.global_conversion_rate') {
      vm.threshold = 'predictions_max_threshold';
    } else {
      vm.threshold = 'predictions_min_threshold';
    }
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      floor: MIN,
      ceil: MAX,
      step: STEP,
      disabled: vm.disabled,
      showSelectionBar: true,
      translate: function(value) {
        return `${value}%`;
      }
    };
    vm.modalId = `modal-${Math.floor(Math.random() * RANDOM_DIGIT)}`;
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    plotBands(vm.campaign[vm.threshold]);
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watch(`$ctrl.campaign.${vm.threshold}`, plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = () => {
    if(deregisterStateChangeStart) deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    const totalSessionCount = sessions.length;
    const nocvSessions = _.filter(sessions, session => session.conversion_count === 0);
    const cvSessions = _.filter(sessions, session => session.conversion_count >= 1);
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonnashi_no_wariai'),
      data: getDistributions(nocvSessions, totalSessionCount)
    });
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonari_no_wariai'),
      data: getDistributions(cvSessions, totalSessionCount)
    });
  }

  function getCategories() {
    return _.map(ranges, range => `${range}-${range + STEP}%`);
  }

  function getDistributions(sessions, totalSessionCount) {
    const countByMin = _.countBy(sessions, session => Math.floor(_.get(session, vm.field) * 100));
    return _.map(ranges, range => {
      const count = countByMin[range] || 0;
      return count / totalSessionCount * 100;
    });
  }

  function plotBands(threshold) {
    if(vm.threshold === 'predictions_max_threshold') {
      vm.chartConfig.xAxis.plotBands = [{
        from: MIN,
        to: threshold,
        color: PLOT_BANDS_COLOR
      }];
    } else {
      vm.chartConfig.xAxis.plotBands = [{
        from: threshold,
        to: MAX,
        color: PLOT_BANDS_COLOR
      }];
    }
  }

  function resizeFull() {
    const $modal = $(`#${vm.modalId}`);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', () => {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    const $modal = $(`#${vm.modalId}`);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly when dynamically changing the screen.
    // Calling the highchartsng.reflow event solves the problem.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/session_prediction_distribution/session_prediction_distribution.js